<router-outlet>
</router-outlet>

<button (click)="backToTop()" id="myBtn" title="Go to top"><i class="fa fa-arrow-up" aria-hidden="true"></i></button>